import type { NotificationInstance } from 'antd/es/notification/interface'
import { attach, createEvent, createStore, sample } from 'effector'

const $notificationInstance = createStore<NotificationInstance | null>(null)

export const notificationInstanceChanged =
  createEvent<NotificationInstance | null>()

type NotificationType = 'success' | 'info' | 'warning' | 'error'
type NotificationPayload = {
  type?: NotificationType
  message?: string
  description?: string
}

const defaultMessages = {
  success: 'Успех',
  info: 'Информация',
  warning: 'Предупреждение',
  error: 'Ошибка',
}

const showNotificationFx = attach({
  source: $notificationInstance,
  effect: (instance, { type = 'info', ...params }: NotificationPayload) => {
    if (!instance) {
      throw new Error('Notification API is not ready')
    }
    const message =
      params.message === '' || params.message === undefined
        ? defaultMessages[type]
        : params.message
    instance[type]({
      key: `notification_${Date.now().toString()}`,
      message: message,
      description: params.description,
    })
  },
})

export const showNotificationSuccessFx = attach({
  mapParams: (params: Omit<NotificationPayload, 'type'>) => ({
    ...params,
    type: 'success' as NotificationType,
  }),
  effect: showNotificationFx,
})

export const showNotificationInfoFx = attach({
  mapParams: (params: Omit<NotificationPayload, 'type'>) => ({
    ...params,
    type: 'info' as NotificationType,
  }),
  effect: showNotificationFx,
})

export const showNotificationWarningFx = attach({
  mapParams: (params: Omit<NotificationPayload, 'type'>) => ({
    ...params,
    type: 'warning' as NotificationType,
  }),
  effect: showNotificationFx,
})

export const showNotificationErrorFx = attach({
  mapParams: (params: Omit<NotificationPayload, 'type'>) => ({
    ...params,
    type: 'error' as NotificationType,
  }),
  effect: showNotificationFx,
})

sample({
  clock: notificationInstanceChanged,
  target: $notificationInstance,
})
